import React from 'react';
import { ExtensionKey } from 'flow/types/EntityKeys';
import ExtensionMentionable from './ExtensionMentionable';

interface Props {
    index: number;
    style: any;
    extensionKey: ExtensionKey;
    isActive: boolean;
    onClick: (event: any) => void;
}

const MentionPickerItem = ({
    index,
    style,
    extensionKey,
    isActive,
    onClick,
}: Props) => {
    return (
        <div style={style} key={`mentionable-${extensionKey}`}>
            <ExtensionMentionable
                extensionKey={extensionKey}
                itemIsActive={isActive}
                className={isActive ? 'active' : ''}
                index={index}
                onClick={onClick}
            />
        </div>
    );
};

export default React.memo(MentionPickerItem);
